module.exports = __webpack_public_path__ + "media/images/svgs/jobs/chauffer-2511a610db1a616e8b7f86b05fa1b054.svg";